import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    openMobileFilter,
} from './../../../actions/FormationActions';
import common from '../../../common';

class FilterBtnMobile extends Component {
    onFilterTapToExpandCollapseInMob = (bool) => {

        this.props.openMobileFilter(bool);
    };

    render() {
        const filterCount = this.props.filterCount;
        const isSIActive = filterCount > 0 && this.props.mobileFilterOpen;
        const filterCountClass = common.makeClasses({
            'si-filter-count': true,
            'si-display-none': filterCount === 0,
        });
        const countIconClass = common.makeClasses({
            'icon-ucl-console': true,
            'si-display-none': filterCount,
        });
        const filterClass = common.makeClasses({
            'si-filter-items': true,
            'si-filters': true,
            'si-active': isSIActive
        });
        return <div className={filterClass} id="priceFilterCalcElement"
            onClick={() => this.onFilterTapToExpandCollapseInMob(true)}>
            <div className="si-filter-item-wrap">
                <i className={countIconClass} />
                <div className={filterCountClass}>{filterCount}</div>
                <span>{this.props.trans.filters}</span>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        filterCount: state.formationData.playerFilters.filterCount,
        mobileFilterOpen: state.formationData.mobileFilterOpen,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        openMobileFilter: (bool) => dispatch(openMobileFilter(bool)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterBtnMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/FilterBtnMobile.js